import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['ParkingLane'],
});
export const parkingLaneApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllParkingLane: builder.mutation({
      query: (from_id) => ({
        url: `lanes/?lane_type__category_code=16&lane_type__code=002&yard=${from_id}`,
        method: 'GET',
      }),
      invalidatesTags: ['ParkingLane'],
    }),
    findParkingLaneById: builder.query({
      query: (id) => `lanes/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ParkingLane', id: result.id }]
          : ['ParkingLane'];
      },
    }),
    createParkingLane: builder.mutation({
      query: (ParkingLane) => ({
        url: `lanes/`,
        method: 'POST',
        body: ParkingLane,
      }),
      invalidatesTags: ['ParkingLane'],
    }),
    updateParkingLane: builder.mutation({
      query: (ParkingLane) => ({
        url: `lanes/${ParkingLane.id}/`,
        method: 'PATCH',
        body: ParkingLane,
      }),
      invalidatesTags: ['ParkingLane'],
    }),
    deleteParkingLane: builder.mutation({
      query: (ParkingLane) => ({
        url: `lanes/${ParkingLane.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ParkingLane'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  // useFindAllParkingLaneQuery,
  useFindAllParkingLaneMutation,
  useFindParkingLaneByIdQuery,
  useCreateParkingLaneMutation,
  useUpdateParkingLaneMutation,
  useDeleteParkingLaneMutation,
} = parkingLaneApi;
